import type { Marker } from '@googlemaps/markerclusterer';
import React, { useCallback } from 'react';
import { AdvancedMarker } from '@vis.gl/react-google-maps';
import { Client } from '../../Models/Client';

export type ClientMarkerProps = {
  client: Client;
  onClick: (client: Client) => void;
  setMarkerRef: (marker: Marker | null, key: string) => void;
};

/**
 * Wrapper Component for an AdvancedMarker for a single tree.
 */
export const ClientMarker = (props: ClientMarkerProps) => {
  const { client, onClick, setMarkerRef } = props;

  const handleClick = useCallback(() => onClick(client), [onClick, client]);
  const ref = useCallback(
    (marker: google.maps.marker.AdvancedMarkerElement) =>
      setMarkerRef(marker, client.id.toString()),
    [setMarkerRef, client.id]
  );

  return (
    <AdvancedMarker
      position={{
        lat: Number(client.latitude),
        lng: Number(client.longitude),
      }}
      ref={ref}
      onClick={handleClick}
    >
      {/* <span className='marker-clustering-tree'>🌳</span> */}
    </AdvancedMarker>
  );
};
